<!-- Watch this thread!!! -->
<!-- https://github.com/devstark-com/vue-google-charts/issues/58 -->
<template>
	<transition
			appear
			:appear-active-class="$_crdCht_styleCardChartAnimation()">
		<v-row no-gutters>
			<v-col>
				<v-row class="rowTop_" no-gutters>
					<v-col>
						<!-- area chart -->
						<template v-if="$_crdCht_chartType == 'area'">
							<card-g-chart
									type="AreaChart"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
						<!-- bar chart -->
						<template v-if="$_crdCht_chartType == 'bar'">
							<card-g-chart
									type="BarChart"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
						<!-- column chart -->
						<template v-if="$_crdCht_chartType == 'column'">
							<card-g-chart
									type="ColumnChart"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
						<!-- curve line chart -->
						<template v-if="$_crdCht_chartType == 'curveLine'">
							<card-g-chart
									type="LineChart"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
						<!-- donut chart -->
						<template v-if="$_crdCht_chartType == 'donut'">
							<card-g-chart
									type="PieChart"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
						<!-- line chart -->
						<template v-if="$_crdCht_chartType == 'line'">
							<card-g-chart
									type="LineChart"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
						<!-- map chart -->
						<template v-if="$_crdCht_chartType == 'map'">
							<card-g-chart
									type="Map"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
						<!-- pie chart -->
						<template v-if="$_crdCht_chartType == 'pie'">
							<card-g-chart
									type="PieChart"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
						<!-- stepped area chart -->
						<template v-if="$_crdCht_chartType == 'steppedArea'">
							<card-g-chart
									type="SteppedAreaChart"
									:data="$_crdCht_getChartData()"
									:options="$_crdCht_getChartOptions()" />
						</template>
					</v-col>
				</v-row>
				<template v-if="$_crdCht_chartType != 'map'">
					<v-row class="rowBottom_" dense justify="center">
						<template v-for="(seriesVal, seriesKey) in $_crdCht_getSeries()">
							<v-col :key="seriesKey" cols="auto">
								<v-chip	:color="googleChartColors[seriesKey]"
										dark
										small>
									<span	class="overline"
											v-text="seriesVal" />
								</v-chip>
							</v-col>
						</template>
					</v-row>
				</template>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'CardChart',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		data() {
			return {
				options_: {
					common: {
						chartArea: {
							width:'80%',
							height:'80%'
						},
						legend: {
							position: 'none'
						}
					},
					curveLine: {
						curveType: 'function',
					},
					donut: {
						pieHole: 0.5
					},
					map: {
						mapType: 'normal',
						showTooltip: true,
						showInfoWindow: true
					}
				}
			}
		},
		computed: {
			// info
			// (content)
			$_crdCht_chart() {
				const self_ = this;
				return self_.contents[self_.contentKey].chart
			},
			$_crdCht_chartHeaders() {
				const self_ = this;
				const chart_ = self_.$_crdCht_chart;
				return chart_.headers
			},
			$_crdCht_chartItems() {
				const self_ = this;
				const chart_ = self_.$_crdCht_chart;
				return chart_.items
			},
			$_crdCht_chartOptions() {
				const self_ = this;
				const chart_ = self_.$_crdCht_chart;
				return chart_.options
			},
			$_crdCht_chartType() {
				const self_ = this;
				const chart_ = self_.$_crdCht_chart;
				return chart_.type
			},
			// style
			$_crdCht_styleCardChart() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'cardChart')
				}
			},
			$_crdCht_styleCardChartAnimation() {
				const self_ = this;
				return () => {
					const chart_ = self_.$_crdCht_styleCardChart()
					if(self_.isFalse(chart_)) { return null }
					return self_.getStylesVal(chart_.animation)
				}
			}
		},
		methods: {
			$_crdCht_getChartData() {
				const self_ = this;

				const headers_ = self_.$_crdCht_chartHeaders;
				const sortedHeaders_ = self_.sortObject(headers_, 'order', 'asc')

				let resHeaders_ = []

				Object.keys(sortedHeaders_).forEach(key => {
					resHeaders_.push(sortedHeaders_[key].title)
				})

				const items_ = self_.$_crdCht_chartItems;
				const sortedItems_ = self_.sortObject(items_, 'order', 'asc')

				let resItems_ = {}

				Object.keys(sortedItems_).forEach(key => {
					resItems_[key] = []

					Object.keys(sortedHeaders_).forEach(headerKey => {
						resItems_[key].push(sortedItems_[key][headerKey])
					})
				})

				let result_ = []

				result_.push(resHeaders_)

				Object.keys(resItems_).forEach(key => {
					result_.push(resItems_[key])
				})

				return result_
			},
			$_crdCht_getChartOptions() {
				const self_ = this;

				const chart_ = self_.$_crdCht_chart;
				const type_ = self_.$_crdCht_chartType;

				let result_ = {}

				if(self_.isEmpty(chart_.options)) { 
					result_ = self_.$_crdCht_getChartOptionsLocal(type_)
				} else {
					result_ = chart_.options;
				}

				return result_
			},
			$_crdCht_getChartOptionsLocal(type) {
				const self_ = this;

				let result_ = {}

				const common_ = self_.options_.common;
				Object.keys(common_).forEach(key => {
					result_[key] = common_[key]
				})

				const local_ = self_.options_[type]
				if(self_.isObject(local_)) {
					Object.keys(local_).forEach(key => {
						result_[key] = local_[key]
					})
				}

				return result_
			},
			$_crdCht_getSeries() {
				const self_ = this;
				
				const data_ = self_.$_crdCht_getChartData()
				const type_ = self_.$_crdCht_chartType;

				let count_ = 0
				let result_ = []

				if(type_ == 'map') { return }

				if(type_ == 'donut' || type_ == 'pie') {
					data_.forEach(row => {
						if(count_ > 0) {
							result_.push(row[0])
						}
						count_++;
					})
				} else {
					const series_ = data_[0]

					series_.forEach(val => {
						if(count_ > 0) {
							result_.push(val)
						}
						count_++;
					})
				}

				return result_
			}
		}
	}
</script>

<style scoped>
	.rowTop_ {
		min-height: 300px;
	}
	.rowBottom_ {
		margin-bottom: 24px;
	}
	.chart_ {
		height: 100%;
		width: 100%;
		padding: 5%;
	}
</style>
